import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background: ${props => props.theme.cards.primary};
  border: 1px solid ${props => props.theme.cards.border};
  box-shadow: ${props => props.theme.shadows.primary};
  border-radius: ${props => props.theme.radius.primary};
  padding: 2rem;
  background: #72169b;
  color: #ffffff;
  overflow: hidden;
  transition: transform 0.5s ease, top 0.5s ease;
  min-width: 450px;
  min-height: 150px;

  @media (max-width: 768px) {
    min-width: 80%;
  }

  &:before {
    content: '';
    position: absolute;
    width: 270px;
    height: 100%;
    background-image: linear-gradient(
      120deg,
      rgba(255, 255, 255, 0) 30%,
      rgba(255, 255, 255, 0.45),
      rgba(255, 255, 255, 0) 70%
    );
    
    top: 0px;
    left: -270px;
    opacity: 0.6;
  }

  &.running {
    background-image: linear-gradient(#fa548a, #ea1fa9) !important;

    &:before {
      animation: 4s ease-out 0s infinite normal none running pulseCronometer;
    }

    @keyframes pulseCronometer {
      0% {
        left: -100px;
      }
      60% {
        left: 100%;
      }
      100% {
        left: 100%;
      }
    }
  }

  &.expanded {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10000; /* Ajuste conforme necessário para sobrepor o overlay */

  }

  > header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
    z-index: 1;

    > aside {
      display: flex;
      gap: 1rem;

      > h1 {
        font-size: 1.5rem;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        justify-content: center;
      }
    }

    > main {
      display: flex;
      gap: 1rem;

      > div {

        > button {
          border: none;
          cursor: pointer;
          background: none;
          outline: none;
          color: #ffffff;
          font-size: 1.25rem;
        }
      }
      
    }
  }

  > footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 1rem;
    z-index: 9;

    > aside {
      display: flex;
      gap: 1rem;

      > h1 {
        font-size: 2.5rem;
        min-width: 200px;
      }
    }

    > main {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 0.2rem;

      > button {
        border: none;
        cursor: pointer;
        background: none;
        outline: none;
      }
    }
  }
`;

export const Timer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
`;

export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  display: none;
  transition: opacity 0.3s ease-in-out;

  &.open {
    display: block;
    opacity: 1;
  }
`;

export const ModalFullScreen = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #00000080;
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(5px);
  transition: all 0.3s ease-in-out;
  z-index: 9999;

  &.open {
    visibility: visible;
    opacity: 1;
  }

  > div {
    padding: 2rem;
    border-radius: 0.5rem;
    box-shadow: 0 0 10px #00000020;
  }
`;